module.exports = __webpack_public_path__ + "static/media/rin-narrow.ebbaccdf.png";